import descargar from '@assets/nuevos-iconos/Descargar1.png'
import postProcessing from '@assets/postProcessing.png'
import borrar from '@assets/nuevos-iconos/Eliminar.png'
import cerrar from '@assets/nuevos-iconos/x.png'
import zoom from '@assets/nuevos-iconos/zOOM JPEG.png'
import { PostProcessingModal } from './PostProcessingModal'
import { useAppStore } from '@store'
import { motion } from 'framer-motion'
import { KeyboardEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Disenyos } from '@types'
import * as Tooltip from '@radix-ui/react-tooltip'

interface ProjectDetailsProps {
  proyect: Disenyos
  refetchProjects: () => void
}

type VisualNombrada = { nombre: string; imageUrl: string; idHqrenders?: number | null }

export function ProjectDetails({ proyect, refetchProjects }: ProjectDetailsProps) {
  const t = useAppStore.use.t()
  const navigate = useNavigate()
  const [navigatedFromHome, setNavigatedFromHome] = useState(false)
  const setStoreFromBack = useAppStore.use.setStoreFromBack()
  const setPendingDesignerInfo = useAppStore.use.setPendingDesignerInfo()
  const setMode = useAppStore.use.setMode()
  const idVers = proyect.disenyo.idVersiones
  const openModal = useAppStore.use.openModal()
  const openProject = useAppStore.use.openProyect()
  const [newInfo, setNewInfo] = useState({
    nombreProyecto: proyect.disenyo.nombreProyecto,
    descripcion: proyect.disenyo.descripcion,
    nombre: proyect.disenyo.nombre,
    apellidos: proyect.disenyo.apellidos,
    direccion: proyect.disenyo.direccion,
    codPostal: proyect.disenyo.codPostal,
    poblacion: proyect.disenyo.poblacion,
    email: proyect.disenyo.email,
    pais: proyect.disenyo.pais,
    movil: proyect.disenyo.movil?.toString(),
    numProyectoTpc: proyect.disenyo.numProyectoTpc || '',
    startDate: proyect.disenyo.fechaCreacion,
    lastModificationDate: proyect.disenyo.fechaUltimaModificacion,
    urlVisor: proyect.disenyo.urlVisor,
    vFecha: proyect.disenyo.vFecha,
    vEmail: proyect.disenyo.vEmail,
    idDisenos: proyect.disenyo.idDisenos,
    precio: proyect.escena.precio,
  })

  const [activeIndex, setActiveIndex] = useState(0)
  const [isZoomed, setIsZoomed] = useState(false)
  const [isPostProcessingOpen, setIsPostProcessingOpen] = useState(false)
  const [processableImages, setProcessableImages] = useState<VisualNombrada[]>([])
  const [processableInitialIndex, setProcessableInitialIndex] = useState(0)
  const visualesNombradasSorted: VisualNombrada[] = Array.isArray(proyect.escena?.visualesNombradas)
    ? [...proyect.escena.visualesNombradas].sort((a) => (a.nombre === '3D' ? -1 : 1))
    : []

  // Función para verificar si una imagen es procesable
  const checkIfImageIsProcessable = async (imageUrl: string): Promise<boolean> => {
    try {
      const params = {
        method: 'HEAD',
        mode: 'cors',
        headers: {
          'Accept-Language': 'ES',
          'Content-Type': 'application/json',
          Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
        },
      }

      const response = await fetch(imageUrl, params as RequestInit)
      return response.ok
    } catch (error) {
      return false
    }
  }

  // Función para filtrar imágenes procesables
  const filterProcessableImages = async (images: VisualNombrada[], currentIndex: number) => {
    const processable: VisualNombrada[] = []
    const checkPromises = images.map(async (img) => {
      const isProcessable = await checkIfImageIsProcessable(img.imageUrl)
      return { img, isProcessable }
    })

    const results = await Promise.all(checkPromises)
    results.forEach(({ img, isProcessable }) => {
      if (isProcessable) {
        processable.push(img)
      }
    })

    // Encontrar el nuevo índice después del filtrado
    let newIndex = 0
    if (currentIndex < images.length) {
      const currentImage = images[currentIndex]
      const foundIndex = processable.findIndex((img) => img.imageUrl === currentImage.imageUrl)
      newIndex = foundIndex >= 0 ? foundIndex : 0
    }

    return { processable, newIndex }
  }

  const handleOpenPostProcessing = async () => {
    if (visualesNombradasSorted.length === 0) return

    const { processable, newIndex } = await filterProcessableImages(
      visualesNombradasSorted,
      activeIndex,
    )

    if (processable.length === 0) {
      // No hay imágenes procesables, no abrir el modal
      console.log('⚠️ No hay imágenes procesables disponibles')
      return
    }

    setProcessableImages(processable)
    setProcessableInitialIndex(newIndex)
    setIsPostProcessingOpen(true)
  }

  const closeZoom = () => {
    setIsZoomed(false)
  }

  useEffect(() => {
    const fromHome = localStorage.getItem('navigatedFromHome')
    if (fromHome === 'true') {
      setNavigatedFromHome(true)
    }
  }, [])
  const setOBBS = useAppStore.use.setOBBScene()
  const handleClick = async () => {
    openProject()
    const designerPayload = {
      disenadorActual: proyect.disenyo.disenadorActual ?? null,
      disenadorOriginal: proyect.disenyo.disenadorOriginal ?? null,
      numProyectoTpc: proyect.disenyo.numProyectoTpc ?? null,
    }

    setPendingDesignerInfo(designerPayload)
    if (navigatedFromHome) {
      navigate('/planner/downloading')
      await setStoreFromBack(idVers, false, false, designerPayload)
      // setMode('MODE_3D_VIEW')
      setTimeout(() => {
        setMode('MODE_IDLE')
        navigate('/planner')
        localStorage.removeItem('navigatedFromHome')
        setOBBS()
      }, 2000)
    } else {
      openModal()
      if (window.location.pathname === '/planner/proyectos') {
        navigate(`/planner/openProject/${idVers}`, { state: { designerInfo: designerPayload } })
      } else {
        // navigate(`/openProject/${idVers}`)
        navigate(`/planner/openProject/${idVers}`, { state: { designerInfo: designerPayload } })
      }
    }
  }

  function formatDate(isoString: string): string {
    const date = new Date(isoString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  function handleInput(e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const target = e.target as HTMLInputElement | HTMLTextAreaElement
    if (target.name === 'fecha') {
      setNewInfo((previous) => ({
        ...previous,
        [target.name]: formatDate(target.value),
      }))
    } else {
      setNewInfo((previous) => ({
        ...previous,
        [target.name]: target.value,
      }))
    }
  }

  const handleDuplicarClick = () => {
    const imagenes = proyect.escena.visualesNombradas
    navigate(`/planner/copyProject/${idVers}`, {
      state: { imagenes: imagenes },
    })
  }

  useEffect(() => {
    const handleKeyDown = (event: globalThis.KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeZoom()
      }
    }

    if (isZoomed) {
      window.addEventListener('keydown', handleKeyDown)
    } else {
      window.removeEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isZoomed])

  const downloadImage = async (imageSrc, imageName = 'descarga') => {
    try {
      const response = await fetch(imageSrc)
      if (!response.ok) throw new Error('Network response was not ok')
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      const date = new Date()
      const formattedDate = date.toLocaleDateString('sv-SE')

      link.href = url
      link.download = `${imageName}-${formattedDate}.png`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error downloading the image: ', error)
    }
  }

  const disenadorActual = proyect.disenyo?.disenadorActual
  const disenadorOriginal = proyect.disenyo?.disenadorOriginal

  return (
    <div className='border-colorAtemporal mb-2 flex h-min w-[1290px] border-[1px] border-solid bg-C/Color1 object-cover p-5'>
      <div className='w-[500px]'>
        <div className=' col-span-4 col-start-1 row-span-3 row-start-1 ml-6 mr-6 grid-flow-row pt-1'>
          <div className='mt-3 flex justify-between'>
            <span className=' text-lg text-C/Color5'>{'Nombre proyecto'}</span>
            <input
              className='ml-4 h-8 flex-1 border border-C/Color4 bg-white/60 px-2  text-base placeholder-C/Color4'
              onKeyDown={(e) => handleInput(e)}
              placeholder={newInfo.nombreProyecto}
              name='newProyectName'
              type='text'
              readOnly
            />
          </div>
          <div
            className='relative mb-4 mt-4'
            style={{ height: '310px', width: '450px' }}
          >
            {visualesNombradasSorted.length > 0 ? (
              <>
                {visualesNombradasSorted.map((png, index) => (
                  <img
                    key={`${index}-${png.nombre}`}
                    loading='lazy'
                    decoding='async'
                    className={`absolute left-0 top-0 z-20 h-full w-full object-cover transition-opacity duration-300 ease-in-out ${
                      index === activeIndex ? 'opacity-100' : 'opacity-0'
                    }`}
                    src={png.imageUrl}
                    alt={png.nombre}
                  />
                ))}

                <div className='absolute bottom-0 left-1/2 z-30 flex -translate-x-1/2 transform space-x-2'>
                  {visualesNombradasSorted.map((_, index) => (
                    <button
                      key={index}
                      className={`mb-3 h-3 w-3 rounded-full ${
                        index === activeIndex ? 'bg-C/Color3' : 'bg-C/Color4'
                      }`}
                      onClick={() => setActiveIndex(index)}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className='flex h-full items-center justify-center text-C/Color5'>
                {'Buscar...' || 'No hay imágenes disponibles'}
              </div>
            )}
          </div>
          <div className=' col-start-11 row-start-1 flex flex-row justify-end gap-6'>
            <Tooltip.Provider>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    className='cursor-pointer'
                    src={zoom}
                    alt='zoom image'
                    onClick={() => setIsZoomed(true)}
                  />
                </Tooltip.Trigger>
                <Tooltip.Content
                  side='top'
                  align='center'
                  className='z-50 rounded bg-C/Color1 p-2 text-sm font-normal leading-4 text-C/Color5 outline outline-[0.5px] outline-C/Color3'
                >
                  {'Zoom imágenes'}
                  <Tooltip.Arrow
                    className='fill-C/Color1 stroke-C/Color3'
                    style={{ strokeWidth: 0.5 }}
                  />
                </Tooltip.Content>
              </Tooltip.Root>
            </Tooltip.Provider>
            {/* <Tooltip.Provider>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    className='h-7 cursor-pointer'
                    src={postProcessing}
                    alt='postProcessing image'
                    onClick={handleOpenPostProcessing}
                  />
                </Tooltip.Trigger>
                <Tooltip.Content
                  side='top'
                  align='center'
                  className='z-50 rounded bg-C/Color1 p-2 text-sm font-normal leading-4 text-C/Color5 outline outline-[0.5px] outline-C/Color3'
                >
                  {'Postprocesado de Imágenes'}
                  <Tooltip.Arrow
                    className='fill-C/Color1 stroke-C/Color3'
                    style={{ strokeWidth: 0.5 }}
                  />
                </Tooltip.Content>
              </Tooltip.Root>
            </Tooltip.Provider> */}
            {/* <Tooltip.Provider>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    className='h-7 cursor-pointer'
                    src={descargar}
                    alt='Descargar'
                    onClick={() => {
                      const imageToDownload = visualesNombradasSorted[activeIndex]
                      downloadImage(imageToDownload.imageUrl, `Descarga-${imageToDownload.nombre}`)
                    }}
                  />
                </Tooltip.Trigger>
                <Tooltip.Content
                  side='top'
                  align='center'
                  className='z-50 rounded bg-C/Color1 p-2 text-sm font-normal leading-4 text-C/Color5 outline outline-[0.5px] outline-C/Color3'
                >
                  {'Descargar imagen'}
                  <Tooltip.Arrow
                    className='fill-C/Color1 stroke-C/Color3'
                    style={{ strokeWidth: 0.5 }}
                  />
                </Tooltip.Content>
              </Tooltip.Root>
            </Tooltip.Provider> */}
            {/* <Tooltip.Provider>
              <Tooltip.Root>
                <Tooltip.Trigger asChild>
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    className='cursor-pointer'
                    src={borrar}
                    alt='Borrar imagen'
                  />
                </Tooltip.Trigger>
                <Tooltip.Content
                  side='top'
                  align='center'
                  className='z-50 rounded bg-C/Color1 p-2 text-sm font-normal leading-4 text-C/Color5 outline outline-[0.5px] outline-C/Color3'
                >
                  {'Eliminar imagen'}
                  <Tooltip.Arrow
                    className='fill-C/Color1 stroke-C/Color3'
                    style={{ strokeWidth: 0.5 }}
                  />
                </Tooltip.Content>
              </Tooltip.Root>
            </Tooltip.Provider> */}
            {isPostProcessingOpen && processableImages.length > 0 && (
              <PostProcessingModal
                open={isPostProcessingOpen}
                onClose={() => setIsPostProcessingOpen(false)}
                images={processableImages}
                initialIndex={processableInitialIndex}
              />
            )}
          </div>

          {isZoomed && (
            <div
              className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80'
              onClick={() => setIsZoomed(false)}
            >
              {/* <button
                onClick={(e) => {
                  e.stopPropagation()
                  setActiveIndex((prevIndex) =>
                    prevIndex > 0 ? prevIndex - 1 : visualesNombradasSorted.length - 1,
                  )
                }}
                className='absolute left-10 text-4xl text-white focus:outline-none'
              >
                {'<'}
              </button> */}
              <img
                src={visualesNombradasSorted[activeIndex].imageUrl}
                className='max-h-[90%] max-w-[90%] p-2'
                alt='Zoomed'
                onClick={(e) => e.stopPropagation()}
              />
              {/* <button
                onClick={(e) => {
                  e.stopPropagation()
                  setActiveIndex((prevIndex) => (prevIndex + 1) % visualesNombradasSorted.length)
                }}
                className='absolute right-10 text-4xl text-white focus:outline-none'
              >
                {'>'}
              </button> */}
              <img
                src={cerrar}
                alt='Cerrar'
                className='absolute right-7 top-7 h-3 w-3 cursor-pointer'
                onClick={() => setIsZoomed(false)}
              />
            </div>
          )}
        </div>
      </div>

      <div className='flex flex-col'>
        <div className='ml-4 grid w-[730px] grid-cols-2 grid-rows-4 gap-x-4 gap-y-2 px-4 text-lg'>
          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Nombre'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.nombre}
              name='newUserName'
              type='text'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>
          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Apellidos'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.apellidos}
              name='newUserSurname'
              type='text'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>
          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Dirección'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.direccion}
              name='newUserAddress'
              type='text'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>

          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Ciudad'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.poblacion}
              name='newUserCity'
              type='text'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>

          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'C.P.'}</label>
            <input
              className='h-8 w-24 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.codPostal}
              name='newUserPostCode'
              type='text'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>

          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Pais'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.pais}
              name='newUserCountry'
              type='text'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>

          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Email'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.email}
              name='newUserEmail'
              type='email'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>

          <div className='flex items-center'>
            <label className='w-24 text-C/Color5'>{'Teléfono'}</label>
            <input
              className='h-8 flex-1 border border-C/Color4 bg-white/60 px-2 placeholder-C/Color4'
              placeholder={newInfo.movil}
              name='newUserPhone'
              type='tel'
              onKeyDown={(e) => handleInput(e)}
              readOnly
            />
          </div>
        </div>

        {/* Descripción debajo de los datos del cliente */}
        <div className='ml-4 mt-2 flex w-[730px] flex-col px-4'>
          <label className='mb-1 text-lg text-C/Color5'>{'Descripción'}</label>
          <textarea
            className='h-[70px] w-full border border-C/Color4 bg-white/60 px-2 text-sm placeholder-C/Color4'
            onKeyDown={(e) => handleInput(e)}
            defaultValue={newInfo.descripcion}
            name='descripcion'
            readOnly
          />
        </div>

        <div className='ml-4 mt-2 grid w-[730px] grid-cols-2 gap-y-1 px-4 text-lg'>
          <div className='flex items-center text-lg text-C/Color5'>
            <span className='w-32'>{'Fecha de inicio'}:</span>
            <span className='ml-2'>
              {new Date(newInfo.startDate).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })}
            </span>
          </div>

          <div className='flex items-center justify-end text-lg text-C/Color5'>
            <span>{'Posición'}:</span>
            <span className='ml-2'>({idVers})</span>
          </div>

          <div className='flex items-center text-lg text-C/Color5'>
            <span className='w-32'>{'Fecha de última modificación'}:</span>
            <span className='ml-2'>
              {new Date(newInfo.lastModificationDate).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })}{' '}
              -{' '}
              {new Date(newInfo.lastModificationDate).toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </div>

          {/* <div className='flex items-center justify-end text-lg text-C/Color5'>
            <span>{'Precio'}:</span>
            <span className='ml-2'>
              {(() => {
                const precioValue: number | string | undefined = newInfo.precio
                let precioNumero: number

                if (typeof precioValue === 'number') {
                  precioNumero = precioValue
                } else if (typeof precioValue === 'string') {
                  const precioStr = String(precioValue)
                  const cleaned = precioStr.replace(/[^\d.,-]/g, '').replace(',', '.')
                  precioNumero = parseFloat(cleaned)
                } else {
                  precioNumero = 0
                }

                if (isNaN(precioNumero)) {
                  return String(precioValue ?? '0')
                }

                // Formatear con punto para miles y coma para decimales
                const partes = precioNumero.toFixed(2).split('.')
                const parteEntera = partes[0]
                const parteDecimal = partes[1] || '00'

                // Agregar puntos cada 3 dígitos desde la derecha
                const parteEnteraFormateada = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

                return `${parteEnteraFormateada},${parteDecimal}`
              })()}{' '}
              €
            </span>
          </div> */}

          {/* Comentado: Ya no habrá visor ni QR
          {newInfo.vFecha && (
            <div className='col-span-2 flex text-lg text-C/Color5'>
              <span>{' Fecha Visor'}:</span>
              <span className='ml-2'>
                {new Date(newInfo.vFecha).toLocaleDateString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
              </span>
            </div>
          )}
          */}

          <div className='col-span-2 mt-1 flex flex-col gap-1'>
            <div className='flex items-center text-lg text-C/Color5'>
              <span className='w-32'>{'Gestor'}:</span>
              <span>
                {disenadorActual && disenadorActual.nombre ? (
                  [disenadorActual.nombre, disenadorActual.correo, disenadorActual.telefono]
                    .filter(Boolean)
                    .join(' / ')
                ) : (
                  <span className='text-gray-400'>—</span>
                )}
              </span>
            </div>
            {disenadorOriginal && disenadorOriginal.nombre && (
              <div className='flex items-center text-lg text-C/Color5'>
                <span className='w-32'>{'Creador'}:</span>
                <span>
                  {[disenadorOriginal.nombre, disenadorOriginal.correo, disenadorOriginal.telefono]
                    .filter(Boolean)
                    .join(' / ')}
                </span>
              </div>
            )}
          </div>

          <div className='col-span-2 mt-3 flex justify-between gap-4'>
            <button
              className='border-colorAtemporal flex h-10 w-56 cursor-pointer items-center justify-center rounded-xl border-[1px] bg-C/Color1 px-4 py-2 text-base font-medium text-C/Color3 shadow-md transition-all hover:border-C/Color4 hover:bg-C/Color2 hover:shadow-lg active:scale-95'
              onClick={handleClick}
            >
              {'Abrir Proyecto'}
            </button>
            <button
              className='border-colorAtemporal flex h-10 w-56 cursor-pointer items-center justify-center rounded-xl border-[1px] bg-C/Color1 px-4 py-2 text-base font-medium text-C/Color3 shadow-md transition-all hover:border-C/Color4 hover:bg-C/Color2 hover:shadow-lg active:scale-95'
              onClick={handleDuplicarClick}
            >
              {'Duplicar'}
            </button>
            <button
              className='border-colorAtemporal flex h-10 w-56 cursor-pointer items-center justify-center rounded-xl border-[1px] bg-C/Color1 px-4 py-2 text-base font-medium text-C/Color3 shadow-md transition-all hover:border-C/Color4 hover:bg-C/Color2 hover:shadow-lg active:scale-95'
              onClick={() => {
                openModal()
                if (window.location.pathname === '/planner/proyectos') {
                  navigate(`/planner/deleteProyect/${idVers}`)
                } else navigate(`/deleteProyect/${idVers}`)
              }}
            >
              {'Borrar Proyecto'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
